import React from 'react';
import Base from '../core/Base';

const UserDashBoard = () => {
	return (
		<Base title="User Cart">
			<h1>This is your personalized cart for purchasing tshirts..</h1>
		</Base>
	);
};

export default UserDashBoard;
